import React, { useContext } from 'react'
import './Farms.scss'
import { ArcContext } from 'src/contexts/ArcContext'
import { getConfigForNetwork } from 'src/config'
import { Table } from '../Table'
import { FarmTableRow } from './FarmTableRow'
import { TabBar } from '../TabBar'
import { Title } from '../Title'

export function Farms() {
  const { network, isPlaynetActivated } = useContext(ArcContext)
  const config = getConfigForNetwork(network, isPlaynetActivated)
  const farms = config?.rewardPools

  const linkUsdFarms = farms?.filter((farm) => farm.pair?.toLowerCase().indexOf('linkusd') !== -1)
  const activeFarms = farms?.filter((farm) => farm.pair?.toLowerCase().indexOf('linkusd') === -1)

  return (
    <div className="farms">
      <div className="farms__container">
        <Title
          title="Farms"
          description="Stake your LP tokens and earn ARCx tokens. Note: 1m GRAEBERS = 1 ARCx token."
          className="farms__title"
        />
        <TabBar
          headerClassName="farms__tab-bar-header"
          items={[
            {
              title: 'Active',
              component: (
                <Table
                  rows={activeFarms?.map((farm) => (
                    <FarmTableRow key={farm.name} rewardPool={farm} />
                  ))}
                  gridTemplateColumns="minmax(1rem, 0.5fr) minmax(12rem, 3fr) minmax(0px, 2fr) minmax(0px, 2fr) minmax(0px, 2fr) minmax(0px, 2fr) minmax(7rem, 2fr)"
                  columnNames={[
                    '#',
                    'Pair',
                    'Platform',
                    'Total Rewards',
                    'Your Earnings',
                    'APY',
                    'Actions',
                  ]}
                />
              ),
            },
            {
              title: 'Archive',
              component: (
                <Table
                  rows={linkUsdFarms?.map((farm) => (
                    <FarmTableRow key={farm.name} rewardPool={farm} />
                  ))}
                  gridTemplateColumns="minmax(1rem, 0.5fr) minmax(12rem, 3fr) minmax(0px, 2fr) minmax(0px, 2fr) minmax(0px, 2fr) minmax(0px, 2fr) minmax(7rem, 2fr)"
                  columnNames={[
                    '#',
                    'Pair',
                    'Platform',
                    'Total Rewards',
                    'Your Earnings',
                    'APY',
                    undefined,
                    'Actions',
                  ]}
                />
              ),
            },
          ]}
        />
      </div>
    </div>
  )
}
